'use client';

import React__default from 'react';
import { HeaderContainer, ImgContainer, Image } from '../../styles.css.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';

var Header = function () {
    return (React__default.createElement(HeaderContainer, null,
        React__default.createElement(Row, null,
            React__default.createElement(Col, { xs: 'auto' },
                React__default.createElement(ImgContainer, { width: '184px', height: '44px' },
                    React__default.createElement(Image, { src: 'https://www.vietnamworks.com/assets-page-container/images/vnw_empower_growth_logo_white.png', alt: 'logo vietnamworks.com', title: 'vietnamworks.com' }))))));
};

export { Header };
//# sourceMappingURL=Header.js.map
